import { FC } from 'react'
import { Link } from 'react-router-dom'

import { useDialog } from 'src/shared/hooks'

import config from 'src/config/app'
import { MenuMobileItemStyled, MenuMobileStyled } from './styles'

export enum MenuMobileCollapsiblesEnum {
  categories = 'categories',
  brands = 'brands',
}
interface MenuMobileProps {
  modalReq: ReturnType<typeof useDialog>
  handleClose: () => void
}

export const MenuMobile: FC<MenuMobileProps> = (props) => {
  return (
    <MenuMobileStyled>
      <MenuMobileItemStyled onClick={props.handleClose}>
        <Link to={'/'}>Inicio</Link>
      </MenuMobileItemStyled>
      <MenuMobileItemStyled onClick={props.handleClose}>
        <Link to={'/aboutus'}>Nosotros</Link>
      </MenuMobileItemStyled>
      <MenuMobileItemStyled onClick={props.handleClose}>
        <Link to={'/products'}>Productos</Link>
      </MenuMobileItemStyled>
      <MenuMobileItemStyled>
        <a target="_blank" href={`${config.files.storePDF}`}>
          Catálogo PDF
        </a>
      </MenuMobileItemStyled>
      <MenuMobileItemStyled
        onClick={() => {
          props.modalReq.handleOpen()
          props.handleClose()
        }}
      >
        Crear Requerimiento
      </MenuMobileItemStyled>
    </MenuMobileStyled>
  )
}
